import { DataLayer } from './tealium/data_layer';
import { listen } from './events/event';
import { IDataLayer, ITealiumSettings } from '../types';

export enum ActionType {
  LINK = 'link',
  VIEW = 'view',
}

window.tealium = window.tealium || {
  dataLayer: {} as DataLayer,
  tealiumUrl: '' as string,
  tealiumProfile: '' as string,
  tealiumEnv: '' as string,
  isSpaReady: false as boolean,
  loaded: false as boolean,
  ready: false as boolean,
  defaultPageViewDisabled: false as boolean,
  pageViews: 0 as number,

  async init(
    { tealiumProfile, tealiumEnv, tealiumUrl }: ITealiumSettings,
    pageData: IDataLayer = {},
  ) {
    this.tealiumProfile = tealiumProfile;
    this.tealiumEnv = tealiumEnv;
    this.tealiumUrl = tealiumUrl || 'tags.tiqcdn.com';
    window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};

    this.dataLayer = new DataLayer();

    if (!this.tealiumEnv || !this.tealiumProfile) {
      return;
    }

    const hostPrefix = window.location.hostname.split('.')[0];
    const isHostElcBuild = window.location.hostname.includes('elcbuild');
    if ((hostPrefix === 'www' || hostPrefix === 'm') && !isHostElcBuild) {
      this.tealiumEnv = 'prod';
    } else if (
      isHostElcBuild ||
      hostPrefix === 'pincer' ||
      hostPrefix === 'wwwtmp'
    ) {
      this.tealiumEnv = 'qa';
    }

    await this.dataLayer.load(pageData);

    if (
      window.location.pathname.endsWith('/checkout') &&
      window._be_platform === 'perlgem'
    ) {
      this.disableDefaultPageView();
    }

    //this.disableDefaultPageView();

    listen(document, ['turbo:before-render'], (event: CustomEvent) => {
      const dataLayerScriptTag =
        event.detail.newBody.querySelector('#data-layer-update');

      if (dataLayerScriptTag) {
        const dataLayer = JSON.parse(dataLayerScriptTag.textContent);
        this.dataLayer.reset(dataLayer);
        this.evtView(this.dataLayer.data);
      }
    });

    listen(window, ['page:loaded'], (e: CustomEvent) => {
      const pageData = e.detail || {};

      if (pageData && this.pageViews > 0) {
        this.dataLayer.load(pageData);
        const dataLayerPageType = this.dataLayer.data.page_type;
        if (
          dataLayerPageType === 'account' &&
          this.dataLayer.data.location.split('/').length == 5
        ) {
          this.dataLayer.data.page_type =
            dataLayerPageType +
            ' - ' +
            this.dataLayer.data.location.split('/')[4];
          this.dataLayer.update();
        }
        if (this.ready) {
          this.evtView({ ...this.dataLayer.data });
        }
      }
    });

    listen(window, ['page_data:updated'], (e: CustomEvent) => {
      const pageData = e.detail || {};
      this.dataLayer.load(pageData, true);
    });

    this.load();
  },

  load(): void {
    window.utag_cfg_ovrd.path = `//${this.tealiumUrl}/utag/esteelauder/${this.tealiumProfile}/${this.tealiumEnv}/`;

    const script = document.createElement('script');
    script.src = window.utag_cfg_ovrd.path + 'utag.js';
    script.type = 'text/javascript';
    script.async = true;

    const onLoadHandler = () => {
      if (!this.loaded) {
        this.loaded = true;
        setTimeout(() => {
          this.ready = true;
          window.dispatchEvent(new CustomEvent('track:ready'));
          if (!this.defaultPageViewDisabled) {
            this.pageViews++;
          }
          this.dataLayer.processEvents();
        }, 500);
      }
    };

    script.addEventListener('load', onLoadHandler);

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  },

  disableDefaultPageView(): void {
    window.utag_cfg_ovrd.noview = true;
    this.defaultPageViewDisabled = true;
  },

  refreshPageData: function () {
    return window.page_data;
  },

  tealiumAPI(type: ActionType, dataLayer: IDataLayer, callback?: void): void {
    if (typeof window.utag !== 'undefined') {
      if (callback) {
        window.utag[type](dataLayer, callback);
      } else {
        window.utag[type](dataLayer);
      }
    }
  },

  evtLink(dataLayer: IDataLayer, callback?: void) {
    this.tealiumAPI(ActionType.LINK, dataLayer, callback);
  },

  evtView(dataLayer: IDataLayer, callback?: void) {
    // TODO: should this update the datalayer? some view events seem to do this, some don't - investigate
    this.tealiumAPI(ActionType.VIEW, dataLayer, callback);
    this.pageViews++;
  },
};

export default window.tealium;
